import { CardAction as KendoCardAction, ActionsLayout as KendoActionsLayout } from "@progress/kendo-angular-layout";

export interface CardAction extends KendoCardAction {}

export type ActionsLayout = KendoActionsLayout;